import Dashboard from '../screens/Dashboard/Dashboard';
import Login from '../screens/Login/Login';
import Splash from '../screens/Splash/Splash';

import CountryManager from '../screens/GeoData/CountryManager/CountryMananger';
import RegionManager from '../screens/GeoData/RegionManager/RegionManager';
import HolidayTypesManager from '../screens/GeoData/HolidayTypesManager/HolidayTypesManager';
import AirportManager from '../screens/GeoData/AirportManager/AirportManager';
import CityManager from '../screens/GeoData/CitiesManager/CitiesManager';
import ZoneManager from '../screens/GeoData/ZoneManager/ZoneManager';
import DestinationAirports from '../screens/GeoData/DestinationAirports/DestinationAirports';

// import BookingsList from '../screens/Orders/BookingList/BookingList';
// import CanceledBookings from '../screens/Orders/CanceledList/CanceledList';
import BookingDetail from '../screens/Booking/BookingDetail/BookingDetail';

import HeaderSettings from '../screens/CMS/Layout/HeaderSettings/HeaderSettings';
import FooterSettings from '../screens/CMS/Layout/FooterSettings/FooterSettings';
import HomepageSettings from '../screens/CMS/Layout/HomepageSettings/HomepageSettings';
import FAQManager from '../screens/CMS/Faq/FAQManager';
import SubscribersManager from '../screens/CMS/Subscribers/Subscribers';
import PageManagementScreen from '../screens/CMS/PageManagement/PageManagement';
import StaticPages from '../screens/CMS/StaticPages/StaticPages';
import SeoPages from '../screens/CMS/SeoPages/SeoPages';

import SupplierManagement from '../screens/Suppliers/SupplierManagement/SupplierManagement';
import SupplierHealthMonitoring from '../screens/Suppliers/SupplierHealthMonitoring/SupplierHealthMonitoring';
import SupplierAPICredentials from '../screens/Suppliers/SupplierAPICredentials/SupplierAPICredentials';

import Airlines from '../screens/Products/Flights/Airlines/Airlines';
import FlightStatus from '../screens/Products/Flights/FlightStatus/FlightStatus';
import SSRManagement from '../screens/Products/Flights/SSR/SSRManagement';
import CabinClasses from '../screens/Products/Flights/CabinClasses/CabinClasses';
import FareClasses from '../screens/Products/Flights/FareClasses/FareClasses';
import FareOptions from '../screens/Products/Flights/FareOptions/FareOptions';
import ScheduleUpdater from '../screens/Products/Flights/ScheduleUpdater/ScheduleUpdater';
import HotelManagment from '../screens/Products/Hotels/HotelManagment/HotelManagment';
import HotelDetails from '../screens/Products/Hotels/HotelDetail/HotelDetails';
import HotelMapping from '../screens/Products/Hotels/Mapping/HotelMapping';

import BookingList from '../screens/Booking/BookingList/BookingList';
import AddBooking from '../screens/Booking/AddBooking/AddBooking';
import ImportedBookings from '../screens/Booking/ImportedBookings/ImportedBookings';

import PrivateCustomers from '../screens/People/Customers/PrivateCustomers/PrivateCustomers';
import PrivateCustomerDetail from '../screens/People/Customers/PrivateCustomers/PrivateCustomersDetail/PrivateCustomersDetail';
import ProfessionalCustomers from '../screens/People/Customers/ProfessionalCustomers/ProfessionalCustomers';
import ProfessionalCustomerDetail from '../screens/People/Customers/ProfessionalCustomers/ProfessionalCustomerDetail/ProfessionalCustomerDetail';
import TravelerList from '../screens/People/Travelers/TravelersList';
import TravelerDetail from '../screens/People/Travelers/TravelerDeatil/TravelerDetail';
import TravelerRules from '../screens/People/Travelers/TravelerRules/TravelerRules';
import CancellationFlow from '../screens/Booking/CancelationFlow/CancelationFlow';

import Markups from '../screens/Pricing&Rules/Markup/Markups';
import PricingLogic from '../screens/Pricing&Rules/PricingLogic/PricingLogic';
import DepositPayment from '../screens/Pricing&Rules/DepositPayment/DepositPayment';
import InsurancePricing from '../screens/Pricing&Rules/InsurancePricing/InsurancePricing';
import MarginEngine from '../screens/Pricing&Rules/MarginEngine/MarginEngine';

// ── System Settings ──────────────────────────────────────────────────────────
import CompanySettings from '../screens/System&Settings/CompanySettings/CompanySettings';
import SequenceSettings from '../screens/System&Settings/SequenceSettings/SequenceSettings';
import ApiSettings from '../screens/System&Settings/ApiSettings/ApiSettings';
import Monitoring from '../screens/System&Settings/Monitoring/Monitoring';
import SupportLevels from '../screens/System&Settings/SupportPackages/SupportLevels';
import SupportServices from '../screens/System&Settings/SupportPackages/SupportServices';

// ── Finance ──────────────────────────────────────────────────────────────────
import Accounts from '../screens/Finance/Accounts/Accounts';
import IncomingPayments from '../screens/Finance/Payments/IncomingPayments/IncomingPayments';
import OutgoingPayments from '../screens/Finance/Payments/OutgoingPayments/OutgoingPayments';
import Refunds from '../screens/Finance/Payments/Refunds/Refunds';
import PaymentMethods from '../screens/Finance/Payments/PaymentMethods/PaymentMethods';
import PaymentReceipts from '../screens/Finance/Payments/PaymentReceipts/PaymentReceipts';
import TransactionList from '../screens/Finance/TransactionList/TransactionList';
import VatSettings from '../screens/Finance/VatManagment/VatSettings/VatSettings';
import SeparateServices from '../screens/Finance/VatManagment/SeparateServices/SeparateServices';
import PackageServices from '../screens/Finance/VatManagment/PackageServices/PackageServices';

// ── Documents (document centre, SUNSKY Documents spec v1.2) ──────────────────
import { Navigate, useLocation } from 'react-router-dom';
import {
  AllDocuments,
  InvoiceDocuments,
  VoucherDocuments,
  BookingDocuments,
} from '../screens/Documents/DocumentCentre/DocumentCentre';
import DispatchHistory from '../screens/Documents/DispatchHistory/DispatchHistory';
import MissingDocuments from '../screens/Documents/MissingDocuments/MissingDocuments';


// ── Reports ──────────────────────────────────────────────────────────────────
import FlightReport from '../screens/Reports/FlightReport/FlightReport';
// Hotel Report (rooming list) replaces the old flat Room Report.
import HotelReport from '../screens/Reports/HotelReport/HotelReport';
import TransferReport from '../screens/Reports/TransferReport/TransferReport';
import InvoiceReport from '../screens/Reports/InvoiceReport/InvoiceReport';
import InsuranceReport from '../screens/Reports/InsuranceReport/InsuranceReport';

// ── Users & Permissions ──────────────────────────────────────────────────────
import UsersOverview from '../screens/UsersPermissions/UsersOverview/UsersOverview';
import Roles from '../screens/UsersPermissions/Roles/Roles';
import PermissionsCatalog from '../screens/UsersPermissions/Permissions/PermissionsCatalog';
import AuditLogs from '../screens/UsersPermissions/AuditLogs/AuditLogs';


// The old one-type-per-screen URLs open the matching submenu with that type
// preset, so bookmarks keep working.
const redirectTo = (to) => {
  const Redirect = () => <Navigate to={to} replace />;
  return Redirect;
};

// Same, but the query string and hash come along: a link like /monitoring?x=1 keeps its x.
const redirectKeepingQuery = (to) => {
  const Redirect = () => {
    const { search, hash } = useLocation();
    return <Navigate to={`${to}${search}${hash}`} replace />;
  };
  return Redirect;
};

export const publicRoutes = [
  {
    path: '/login',
    component: Login,
  },
];

export const protectedRoutes = [
  {
    path: '/splash',
    component: Splash,
    layout: false,
  },
  {
    path: '/dashboard',
    component: Dashboard,
  },

  // ── Orders ───────────────────────────────────────────────────────────────
  // {
  //   path: '/orders/bookings',
  //   component: BookingsList,
  // },
  // {
  //   path: '/orders/canceled-bookings',
  //   component: CanceledBookings,
  // },

  // ── Bookings ─────────────────────────────────────────────────────────────
  {
    path: '/bookings',
    component: BookingList,
  },
  {
    path: '/bookings/add',
    component: AddBooking,
  },
  // Declared before /bookings/:ref, or "imported" is read as a booking ref and
  // opens the booking detail screen on a booking that does not exist.
  {
    path: '/bookings/imported',
    component: ImportedBookings,
  },
  {
    path: '/bookings/:ref',
    component: BookingDetail,
  },

  // ── Products › Flights ───────────────────────────────────────────────────
  {
    path: '/products/flights/airlines',
    component: Airlines,
  },
  {
    path: '/products/flights/flight-status',
    component: FlightStatus,
  },
  {
    path: '/products/flights/ssr',
    component: SSRManagement,
  },
  {
    path: '/products/flights/cabin-classes',
    component: CabinClasses,
  },
  {
    path: '/products/flights/fare-classes',
    component: FareClasses,
  },
  {
    path: '/products/flights/fare-options',
    component: FareOptions,
  },
  {
    path: '/products/flights/schedule-updater',
    component: ScheduleUpdater,
  },

  // ── Products › Hotels ────────────────────────────────────────────────────
  {
    path: '/products/hotels/management',
    component: HotelManagment,
  },
  {
    path: '/products/hotels/details/:hotelId',
    component: HotelDetails,
  },
  {
    path: '/products/hotels/mapping',
    component: HotelMapping,
  },

  // ── GeoData ──────────────────────────────────────────────────────────────
  {
    path: '/geodata/countries',
    component: CountryManager,
  },
  {
    path: '/geodata/regions',
    component: RegionManager,
  },
  {
    path: '/geodata/holidaytypes',
    component: HolidayTypesManager,
  },
  {
    path: '/geodata/airports',
    component: AirportManager,
  },
  {
    path: '/geodata/cities',
    component: CityManager,
  },
  {
    path: '/geodata/zones',
    component: ZoneManager,
  },
  {
    path: '/geodata/destination-airports',
    component: DestinationAirports,
  },

  // ── CMS ──────────────────────────────────────────────────────────────────
  {
    path: '/cms/layout/header',
    component: HeaderSettings,
  },
  {
    path: '/cms/layout/footer',
    component: FooterSettings,
  },
  {
    path: '/cms/layout/homepage',
    component: HomepageSettings,
  },
  {
    path: '/cms/faqs',
    component: FAQManager,
  },
  {
    path: '/cms/subscribers',
    component: SubscribersManager,
  },
  {
    path: '/cms/pages',
    component: PageManagementScreen,
  },
  {
    path: '/cms/static-pages',
    component: StaticPages,
  },
  {
    path: '/cms/seo',
    component: SeoPages,
  },

  // ── Suppliers ────────────────────────────────────────────────────────────
  {
    path: '/suppliers/management',
    component: SupplierManagement,
  },
  {
    path: '/suppliers/health',
    component: SupplierHealthMonitoring,
  },
  {
    path: '/suppliers/api-credentials',
    component: SupplierAPICredentials,
  },

  // ── People › Customers ───────────────────────────────────────────────────
  {
    path: '/people/customers/private',
    component: PrivateCustomers,
  },
  {
    path: '/people/customers/private/:ref',
    component: PrivateCustomerDetail,
  },
  {
    path: '/people/customers/professional',
    component: ProfessionalCustomers,
  },
  {
    path: '/people/customers/professional/:ref',
    component: ProfessionalCustomerDetail,
  },

  // ── People › Travelers ───────────────────────────────────────────────────
  {
    path: '/people/travelers/profiles',
    component: TravelerList,
  },
  {
    path: '/people/travelers/:id',
    component: TravelerDetail,
  },
  {
    path: '/people/travelers/rules',
    component: TravelerRules,
  },
  {
    path: '/bookings/cancellation',
    component: CancellationFlow,
  },

  // ── Pricing & Rules ───────────────────────────────────────────────────────
  {
    // The central Margin Engine: one menu for all seven product margins.
    path: '/pricing/margin-engine',
    component: MarginEngine,
  },
  {
    path: '/pricing/markups',
    component: Markups,
  },
  {
    path: '/pricing/pricing-logic',
    component: PricingLogic,
  },
  {
    path: '/pricing/deposit-payment',
    component: DepositPayment,
  },
  {
    path: '/pricing/insurance',
    component: InsurancePricing,
  },

  // ── System Settings ───────────────────────────────────────────────────────
  // Monitoring first: it is the page you open when something is wrong, where the rest are
  // configuration you open deliberately (Master Ch 1 §12A).
  {
    path: '/system/monitoring',
    component: Monitoring,
  },
  // The incident alert emails link to ADMIN_APP_URL + /monitoring (backend opsAlert.service.js
  // alertIncident), and the dashboard's "Action required" rows link here too. One canonical
  // page: /monitoring lands on /system/monitoring, so the sidebar shows where you are.
  {
    path: '/monitoring',
    component: redirectKeepingQuery('/system/monitoring'),
  },
  {
    path: '/system/company',
    component: CompanySettings,
  },
  {
    path: '/system/sequences',
    component: SequenceSettings,
  },
  {
    path: '/system/api',
    component: ApiSettings,
  },
  {
    path: '/system/support-levels',
    component: SupportLevels,
  },
  {
    path: '/system/support-services',
    component: SupportServices,
  },

  // ── Finance ───────────────────────────────────────────────────────────────
  {
    path: '/finance/accounts',
    component: Accounts,
  },
  {
    path: '/finance/payments/incoming',
    component: IncomingPayments,
  },
  {
    path: '/finance/payments/outgoing',
    component: OutgoingPayments,
  },
  {
    path: '/finance/payments/refunds',
    component: Refunds,
  },
  {
    path: '/finance/payments/methods',
    component: PaymentMethods,
  },
  {
    path: '/finance/receipts',
    component: PaymentReceipts,
  },
  {
    path: '/finance/transactions',
    component: TransactionList,
  },
  {
    path: '/finance/vat/settings',
    component: VatSettings,
  },
  {
    path: '/finance/vat/separate-services',
    component: SeparateServices,
  },
  {
    path: '/finance/vat/package-services',
    component: PackageServices,
  },

  // ── Documents ─────────────────────────────────────────────────────────────
  { path: '/documents', component: AllDocuments },
  { path: '/documents/invoices', component: InvoiceDocuments },
  { path: '/documents/vouchers', component: VoucherDocuments },
  { path: '/documents/booking-documents', component: BookingDocuments },
  { path: '/documents/dispatch-history', component: DispatchHistory },
  { path: '/documents/missing-travel-documents', component: MissingDocuments },

  // Old per-type screens → the submenu with that type preset.
  { path: '/documents/invoices/sales', component: redirectTo('/documents/invoices?types=sales_invoice') },
  { path: '/documents/invoices/credit-notes', component: redirectTo('/documents/invoices?types=credit_invoice') },
  { path: '/documents/invoices/debit-notes', component: redirectTo('/documents/invoices?types=debit_notes') },
  { path: '/documents/vouchers/flight', component: redirectTo('/documents/vouchers?types=flight_voucher') },
  { path: '/documents/vouchers/hotel', component: redirectTo('/documents/vouchers?types=hotel_voucher') },
  { path: '/documents/vouchers/transfer', component: redirectTo('/documents/vouchers?types=transfer_voucher') },
  {
    path: '/documents/booking-documents/confirmations',
    component: redirectTo('/documents/booking-documents?types=booking_confirmation'),
  },
  { path: '/documents/booking-documents/ssr', component: redirectTo('/documents/booking-documents?types=ssr_confirmation') },
  {
    path: '/documents/booking-documents/insurance',
    component: redirectTo('/documents/booking-documents?types=insurance_confirmation'),
  },

  // ── Reports ───────────────────────────────────────────────────────────────
  {
    path: '/reports/flights',
    component: FlightReport,
  },
  {
    path: '/reports/hotels',
    component: HotelReport,
  },
  {
    // Legacy alias — the old Room Report URL now shows the Hotel Report.
    path: '/reports/rooms',
    component: HotelReport,
  },
  {
    path: '/reports/transfers',
    component: TransferReport,
  },
  {
    path: '/reports/invoices',
    component: InvoiceReport,
  },
  {
    path: '/reports/insurance',
    component: InsuranceReport,
  },

  // ── Users & Permissions ───────────────────────────────────────────────────
  {
    path: '/users/overview',
    component: UsersOverview,
  },
  {
    path: '/users/roles',
    component: Roles,
  },
  {
    path: '/users/permissions',
    component: PermissionsCatalog,
  },
  {
    path: '/users/audit',
    component: AuditLogs,
  },
];